import React, { useState, useRef, useEffect } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import moment from "moment";
import useTableScroll from "../../components/useTableScroll";
import { formatBytes } from "../../util/varios";

const GenerarVersion = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");

  const RefFile = useRef();
  const cmbStatus = useRef();
  const cmbTipo = useRef();
  const txtVersion = useRef();
  const txtNotav = useRef();
  const txtParrafo1 = useRef();
  const txtParrafo2 = useRef();
  const txtParrafo3 = useRef();

  const headCells = [
    { label: "NOMBRE", textAlign: "center", with: 300 },
    { label: "TAMAÑO", textAlign: "center", with: 100 },
    { label: "FECHA", textAlign: "center", with: 100 },
    { label: "DESCARGAR", textAlign: "center", with: 50 },
    { label: "ELIMINAR", textAlign: "center", with: 50 },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const [lista, setLista] = useState([]);
  const [apk, setApk] = useState("");
  const [pathApk, setPathApk] = useState("Seleccionar Archivo");

  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    aceptar: true,
    cancelar: true,
  });

  const handleUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setPathApk(file.name);
      setApk(e.target.files[0]);
    }
  };

  const onChangeValidar = () => {
    let sigue = true;
    let upload = new FormData();
    if (RefFile.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "debe seleccionar un archivo apk",
        icono: "informacion",
      });
      sigue = false;
      RefFile.current.focus();
    } else if (txtVersion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "el campo version no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtVersion.current.focus();
    } else {
      upload.append("operacion", 1);
      upload.append(
        "version",
        JSON.stringify([
          {
            idversion: "0",
            version: txtVersion.current.value,
            tipo: cmbTipo.current.value,
            status: cmbStatus.current.value,
            notaversion: txtNotav.current.value.trim(),
            notauno: txtParrafo1.current.value.trim(),
            notados: txtParrafo2.current.value.trim(),
            notatres: txtParrafo3.current.value.trim(),
          },
        ])
      );
      upload.append("nueva", apk);
    }

    if (sigue) {
      procesarRegistro(upload);
    }
  };

  const procesarRegistro = (body) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/athos/version/actualizar`;

    axios
      .post(endpoint, body, {
        responseType: "arraybuffer",
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        getFTP();
        txtNotav.current.value = "";
        txtParrafo1.current.value = "";
        txtParrafo2.current.value = "";
        txtParrafo3.current.value = "";
        txtVersion.current.value = "";
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "Proceso ejecutado correctamente",
          icono: "exito",
        });
      })
      .catch((error) => {
        console.error(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error Al Crear El Respaldo",
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op !== 6) {
      setVisibleBtn("hidden");
    } else {
      setVisibleBtn("visible");
    }

    if (op === 1) {
      setHabilitado(false);
      setBotones({
        incluir: false,
        aceptar: false,
        cancelar: false,
      });
    } else if (op === 5) {
      onChangeValidar();
    }
  };

  const getFTP = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/athos/version/listar?dir=version`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setLista(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => setActivate(false));
  };

  const getDescargar = (ruta, file) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/athos/version/descargar?ruta=${ruta}&archivo=${file}`;
    axios
      .get(endpoint, {
        responseType: "arraybuffer",
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${file}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setActivate(false));
  };

  const eliminar = (ruta) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/athos/version/eliminar?ruta=${ruta}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          getFTP();
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: response.data,
            icono: "exito",
          });
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setActivate(false));
  };

  useEffect(() => {
    getFTP();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="col-md-12 mx-auto row">
        <div className="col-md-12 py-2 row card">
          <div className="col-md-12 mx-auto rounded py-2  border-azul ">
            <div className=" row rounded px-0 d-flex justify-content-between">
              <div className="input-group mb-3">
                <input
                  className="form-control"
                  ref={RefFile}
                  name="apk"
                  accept="*"
                  onChange={handleUpload}
                  type="file"
                  id="apk"
                />
              </div>
              <div className="input-group mb-3 input-group-sm  col-md-12">
                <label className="input-group-text" id="version">
                  Nota de la Version:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  ref={txtNotav}
                  name="version"
                  placeholder="Titulo de la nota de la version"
                  className="form-control"
                  aria-label="version"
                  aria-describedby="version"
                />
              </div>
              <div className="input-group mb-3 input-group-sm  col-md-12">
                <label className="input-group-text" id="version">
                  Parrafo 1:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  ref={txtParrafo1}
                  name="version"
                  placeholder="Descripcion de la nota de la version 1"
                  className="form-control"
                  aria-label="version"
                  aria-describedby="version"
                />
              </div>
              <div className="input-group mb-3 input-group-sm  col-md-12">
                <label className="input-group-text" id="version">
                  Parrafo 2:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  ref={txtParrafo2}
                  name="version"
                  placeholder="Descripcion de la nota de la version 2"
                  className="form-control"
                  aria-label="version"
                  aria-describedby="version"
                />
              </div>
              <div className="input-group mb-3 input-group-sm  col-md-12">
                <label className="input-group-text" id="version">
                  Parrafo 3:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  ref={txtParrafo3}
                  name="version"
                  placeholder="Descripcion de la nota de la version 3"
                  className="form-control"
                  aria-label="version"
                  aria-describedby="version"
                />
              </div>
              <div className="input-group mb-3 input-group-sm  col-md-3">
                <label className="input-group-text" id="version">
                  Version:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  ref={txtVersion}
                  name="version"
                  placeholder="1.0.0"
                  className="form-control uppercase"
                  aria-label="version"
                  aria-describedby="version"
                />
              </div>
              <div className="input-group mb-3 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  ESTATUS:
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example col-md-4"
                  name="status"
                  ref={cmbStatus}
                >
                  <option value={"ESTABLE"}>ESTABLE</option>
                  <option value={"BETA"}>BETA</option>
                </select>
              </div>
              <div className="input-group mb-3 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  TIPO:
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example col-md-4"
                  name="tipo"
                  ref={cmbTipo}
                >
                  <option value={"APK"}>APK</option>
                  <option value={"OTRO"}>OTRO</option>
                </select>
              </div>
              <div className="col-sm-3">
                <button
                  disabled={botones.incluir}
                  onClick={onBotones(5)}
                  className="btn btn-sm mx-1 btn-primary rounded-pill"
                  style={{ height: "27px" }}
                  title="Guardar"
                >
                  <i style={{ fontSize: "9px" }} className="fas fa-plus">
                    {" "}
                    Guardar
                  </i>{" "}
                </button>
              </div>
            </div>

            <div className="col-md-12 mt-2 d-flex justify-content-end">
              {
                /* visibleBtn === "visible" ?  */ <div
                  className="col-md-12 d-flex justify-content-start"
                /* style={{ visibility: visibleBtn }} */
                ></div> /* : (
                <div
                  className="col-md-5 d-flex justify-content-end"
                  style={{
                    visibility: visibleBtn === "visible" ? "hidden" : "visible",
                  }}
                >
                  <button
                    disabled={botones.aceptar}
                    onClick={onBotones(5)}
                    ref={btnAcepta}
                    style={{ height: "27px" }}
                    className="mx-2 btn btn-sm rounded-pill btn-success"
                  >
                    <i
                      className="fas fa-check-circle"
                      style={{ fontSize: "9px" }}
                    >
                      {" "}
                      Aceptar
                    </i>
                  </button>
                  <button
                    disabled={botones.cancelar}
                    onClick={onBotones(6)}
                    ref={btnCancela}
                    style={{ height: "27px" }}
                    className="mx-2 btn btn-danger btn-sm rounded-pill"
                  >
                    <i
                      className="fas fa-window-close"
                      style={{ fontSize: "9px" }}
                    >
                      {" "}
                      Cancelar
                    </i>
                  </button>
                </div>
              ) */
              }
            </div>
          </div>
        </div>

        <div className="row col-md-12">
          <TblContainer
            container={{
              maxHeight: 300,
              minHeight: 300,
              width: "100%",
              overflow: "auto",
            }}
          >
            <TblHead />
            <tbody>
              {lista &&
                lista.map((item, index) => (
                  <tr
                    style={{
                      cursor: "pointer",
                    }}
                    key={index}
                  >
                    <td
                      className="align-baseline letra-tabla-td text-start"
                      style={{ width: 100 }}
                    >
                      {item.type === "dir" ? (
                        <i className="fas fa-folder">{" " + item.name}</i>
                      ) : (
                        item.name
                      )}
                    </td>
                    <td
                      className="align-baseline letra-tabla-td text-right"
                      style={{ width: 40 }}
                    >
                      {formatBytes(item.size)}
                    </td>
                    <td
                      className="align-baseline letra-tabla-td text-center"
                      style={{ width: 100 }}
                    >
                      {moment(item.date).format("DD-MM-YYYY")}
                    </td>
                    <td
                      className="align-baseline letra-tabla-td text-center"
                      style={{ width: 10 }}
                    >
                      {item.type !== "dir" && (
                        <button
                          className="btn btn-sm  btn-info rounded-circle ml-2"
                          onClick={() => getDescargar(item.route, item.name)}
                        >
                          <i className="fas fa-download"></i>
                        </button>
                      )}
                    </td>
                    <td
                      className="align-baseline letra-tabla-td text-center"
                      style={{ width: 10 }}
                    >
                      {item.type !== "dir" && (
                        <button
                          className="btn btn-sm  btn-danger rounded-circle ml-2"
                          onClick={() => eliminar(item.route)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
        </div>
      </div>

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default GenerarVersion;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/generarVersion.js